import React, { useState, useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Autoplay } from "swiper/modules";
import "../../App.css";
import axios from "axios";

import { useNavigate } from "react-router-dom";
import { base_url } from "../../config";
// import img from "../../images/image-589_"

export default function ImageSliderHero({ setIsVisible, dummyData }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [slideData, setSlideData] = useState([]); // Correctly named state variable
  const [baseUrl, setBaseUrl] = useState("");
  const swiperRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.realIndex);
  };

  const handleNext = () => {
    if (swiperRef.current) swiperRef.current.slideNext();
  };

  const handlePrev = () => {
    if (swiperRef.current) swiperRef.current.slidePrev();
  };

  const fetchImages = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${base_url}/tables/list-public`
      );
      setTimeout(() => {
        setLoading(false);
        setSlideData(response.data.items);
        setBaseUrl(response.data.meta.base_url.table_photo);
      }, 1000);
    } catch (error) {
      console.error("Error fetching images:", error);
    }
  };

  const handleNavigate = (name, id) => {
    const formattedName = name.replace(/\s+/g, "-"); // Replace spaces with dashes
    navigate(`/details?table=${encodeURIComponent(formattedName)}&id=${id}`);
  };

  const accessToken = localStorage.getItem("@user");

  function formatDate(dateString) {
    if (!dateString) return "";
    const [day, month, year] = dateString.split(" ")[0].split("-");
    const date = new Date(`${year}-${month}-${day}`);
    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
    });
  }

  function formatTime(dateString) {
    if (!dateString) return "";
    const [day, month, year, time] = [
      ...dateString.split(" ")[0].split("-"),
      dateString.split(" ")[1],
    ];
    const date = new Date(`${year}-${month}-${day}T${time}`);
    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  }
  useEffect(() => {
    fetchImages();
  }, []);

  return (
    <section className="slider">
      {dummyData.length <= 0 || loading ? (
        <div
          role="status"
          className="swiper-slide relative card bg-gray-500 animate-pulse "
        >
          <span className="sr-only">Loading...</span>
        </div>
      ) : (
        <div className="swiper-wrapper  relative">
          <Swiper
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            navigation={false} // Disable default navigation
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            onSlideChange={handleSlideChange}
            modules={[Navigation, Autoplay]}
            className="rounded-3xl"
          >
            {dummyData?.map((slide, index) => (
              <div key={slide.id}>
                <SwiperSlide
                  key={slide.id}
                  // onClick={() => handleNavigate(slide?.title, slide.id)}
                  className={`swiper-slide pointer relative card p-2 ${
                    index === activeIndex - 1 ? "gray-overlay" : ""
                  }`}
                >
                  <div
                    className="absolute inset-0 bg-cover bg-center "
                  
                    style={{
                      backgroundImage: `url(${slide.media})`,
                    }}
                  ></div>
                  {/* <div className="dark-gradiant-overlay  "></div> */}
                  <div className="new-dark-gradiant-overlay "></div>
                  <div className="swiper-slide-content mt-40">
                    {/* <div className="category-div">
                      <p className="category">{slide?.category.name}</p>
                    </div>
                    <div className="table-heading-featured">
                      <h1 className="heading">{slide.title}</h1>
                    </div> */}

                    {/* <div className="swiper-content-host">
                      <div className="host-dp">
                        <img
                          loading="lazy"
                          src={
                            slide.user_profile.photo
                              ? `https://s3.ap-south-1.amazonaws.com/high-table-2024/public/photo/members/${slide?.user_profile.photo}`
                              : "../../static/media/user-icon-1.62f73db9586c0e3b573a.svg"
                          }
                          alt="Card preview"
                          className="host-image-on-card"
                        />
                      </div>
                      <p className="host-name">
                        {slide.user_profile?.first_name}
                        &nbsp;
                        {slide.user_profile?.last_name}
                      </p>
                    </div> */}
                    {/* <div className="featured-date-location">
                      <div className="swiper-content-date">
                        <div className="location-icon">
                          <div className="code-embed w-embed">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              x="0px"
                              y="0px"
                              width={20}
                              height={20}
                              viewBox="0,0,256,256"
                            >
                              <g
                                fill="#ffffff"
                                fillRule="nonzero"
                                stroke="none"
                                strokeWidth={1}
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeMiterlimit={10}
                                strokeDasharray=""
                                strokeDashoffset={0}
                                fontFamily="none"
                                fontWeight="none"
                                fontSize="none"
                                textAnchor="none"
                                style={{ mixBlendMode: "normal" }}
                              >
                                <g transform="scale(5.33333,5.33333)">
                                  <path d="M42,14v-1.5c0,-3.584 -2.916,-6.5 -6.5,-6.5h-23c-3.584,0 -6.5,2.916 -6.5,6.5v1.5zM6,17v18.5c0,3.584 2.916,6.5 6.5,6.5h23c3.584,0 6.5,-2.916 6.5,-6.5v-18.5zM15.5,36c-1.381,0 -2.5,-1.119 -2.5,-2.5c0,-1.381 1.119,-2.5 2.5,-2.5c1.381,0 2.5,1.119 2.5,2.5c0,1.381 -1.119,2.5 -2.5,2.5zM15.5,27c-1.381,0 -2.5,-1.119 -2.5,-2.5c0,-1.381 1.119,-2.5 2.5,-2.5c1.381,0 2.5,1.119 2.5,2.5c0,1.381 -1.119,2.5 -2.5,2.5zM24,36c-1.381,0 -2.5,-1.119 -2.5,-2.5c0,-1.381 1.119,-2.5 2.5,-2.5c1.381,0 2.5,1.119 2.5,2.5c0,1.381 -1.119,2.5 -2.5,2.5zM24,27c-1.381,0 -2.5,-1.119 -2.5,-2.5c0,-1.381 1.119,-2.5 2.5,-2.5c1.381,0 2.5,1.119 2.5,2.5c0,1.381 -1.119,2.5 -2.5,2.5zM32.5,27c-1.381,0 -2.5,-1.119 -2.5,-2.5c0,-1.381 1.119,-2.5 2.5,-2.5c1.381,0 2.5,1.119 2.5,2.5c0,1.381 -1.119,2.5 -2.5,2.5z" />
                                </g>
                              </g>
                            </svg>
                          </div>
                        </div>
                        <p className="host-name flex flex-col md:flex-row gap-1">
                          <span className="event-date">
                            {formatDate(slide?.event_date)}
                          </span>
                          <span className="event-time hidden md:inline">
                            , {formatTime(slide?.event_date)}
                          </span>
                        </p>
                      </div>
                      <div className="swiper-content-date">
                        <div className="date-icon">
                          <div className="code-embed w-embed">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              x="0px"
                              y="0px"
                              width={20}
                              height={20}
                              viewBox="0,0,256,256"
                            >
                              <g
                                fill="#ffffff"
                                fillRule="nonzero"
                                stroke="none"
                                strokeWidth={1}
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeMiterlimit={10}
                                strokeDasharray=""
                                strokeDashoffset={0}
                                fontFamily="none"
                                fontWeight="none"
                                fontSize="none"
                                textAnchor="none"
                                style={{ mixBlendMode: "normal" }}
                              >
                                <g transform="scale(5.33333,5.33333)">
                                  <path d="M24,4c-9.374,0 -17,7.626 -17,17c0,4.036 1.449,7.953 4.093,11.048c0.302,0.343 7.427,8.439 9.807,10.708c0.869,0.829 1.984,1.244 3.1,1.244c1.116,0 2.231,-0.415 3.101,-1.244c2.767,-2.639 9.524,-10.385 9.82,-10.725c2.63,-3.078 4.079,-6.995 4.079,-11.031c0,-9.374 -7.626,-17 -17,-17zM24,26c-2.761,0 -5,-2.239 -5,-5c0,-2.761 2.239,-5 5,-5c2.761,0 5,2.239 5,5c0,2.761 -2.239,5 -5,5z" />
                                </g>
                              </g>
                            </svg>
                          </div>
                        </div>
                        <p className="host-name md:hidden">
                          {" "}
                          {slide?.city ? (
                            <>
                              {slide?.city?.length > 10
                                ? `${slide.city.substring(0, 10)}...`
                                : slide.city}
                            </>
                          ) : (
                            <>Bangalore</>
                          )}
                        </p>

                        <p className="host-name hidden md:inline">
                          {slide?.city}
                        </p>
                      </div>
                    </div> */}
                  </div>
                </SwiperSlide>
              </div>
            ))}
          </Swiper>

          {/* Custom Progress Bar */}
          <div className="progress-pagination">
            {dummyData.map((_, index) => (
              <div
                key={index}
                className={`progress-bar ${
                  index === activeIndex
                    ? "active"
                    : index < activeIndex
                    ? "completed"
                    : ""
                }`}
              >
                {index === activeIndex && (
                  <div className="progress-indicator"></div>
                )}
              </div>
            ))}
          </div>

          {/* Navigation Arrows */}
          {activeIndex > 0 && (
            <button
              type="button"
              aria-label="Prev"
              className="tinyflow-slider__arrow tinyflow-slider__arrow--prev"
              onClick={handlePrev}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1em"
                height="1em"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
                ></path>
              </svg>
            </button>
          )}
          {activeIndex !== dummyData.length - 1 && (
            <button
              type="button"
              aria-label="Next"
              className="tinyflow-slider__arrow tinyflow-slider__arrow--next"
              onClick={handleNext}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1em"
                height="1em"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
                ></path>
              </svg>
            </button>
          )}
        </div>
      )}
    </section>
  );
}
